var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-rule-page"},[_c('div',{staticClass:"rule_content",domProps:{"innerHTML":_vm._s(_vm.activityRule)}}),_c('div',{staticClass:"bottom_float_btn"},[_c('button',{on:{"click":_vm.back}},[_vm._v("返回")])])])}
var staticRenderFns = []

export { render, staticRenderFns }